import appconfig from '@/utils/appConfig';

const FormDivider = () => {
    return (
        <div
            className={`flex border w-full ${appconfig.colors.coloredSectionBorder} my-4`}
        />
    );
};

export default FormDivider;
